import { toast } from "react-toastify";
import { AI_SCHEDULE_MATRIX } from "../config/apiEndPoint";
import { GET, POST, PUT, DEL } from "config/api.config";

const buildQueryUrl = (base, params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    search.append(key, String(value));
  });
  const qs = search.toString();
  return qs ? `${base}?${qs}` : base;
};

export const fetchAIScheduleMatrixTableAndFilterSchema = async (data = {}) => {
  try {
    const response = await GET(AI_SCHEDULE_MATRIX.METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitAIScheduleMatrixFilterData = async (data = {}) => {
  try {
    const url = buildQueryUrl(AI_SCHEDULE_MATRIX.LIST, data);
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addAIScheduleMatrix = async (data = {}) => {
  try {
    const response = await POST(AI_SCHEDULE_MATRIX.LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateAIScheduleMatrix = async (id, data = {}) => {
  try {
    const response = await PUT(AI_SCHEDULE_MATRIX.BY_ID(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const deleteAIScheduleMatrix = async (id = "") => {
  const raw = String(id ?? "").trim();
  if (!raw) {
    toast.error("Record ID is required");
    return;
  }
  try {
    const response = await DEL(AI_SCHEDULE_MATRIX.BY_ID(raw));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
